import React, { useEffect, useState } from 'react';

import {
  Grid,
  Box,
  Typography,
  Button,
  CardContent,
  Card,
  Backdrop,
  CardHeader,
  Avatar,
} from '@mui/material';
import PropTypes from 'prop-types';
import { classes } from './utils';
import { ReactComponent as EditIcon } from '../../../../assets/accountSetting-assets/EditIcon.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/accountSetting-assets/DeleteIcon.svg';
import { darkPalette } from '../../../../theme';
import closeIcon from '../../../../assets/accountSetting-assets/x-circle.svg';

const CardComponent = (props) => {
  const {
    Icon,
    credential,
    type,
    displayName,
    taxMapping,
    id,
    handleDeleteCredential,
    handleUpdate,
  } = props;
  const [credentialData, setCredentialData] = useState([]);
  const [taxData, setTaxData] = useState([]);
  const [isShowMore, setIsShowMore] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteData, setDeleteData] = useState({
    credentialId: null,
    selectedType: null,
  });

  const handleOpenDialog = (credentialId, selectedType) => {
    setDeleteData({ credentialId, selectedType });
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setDeleteData({ id: null, selectedType: null });
  };

  useEffect(() => {
    let data;
    if (type === 'TallyPrime') {
      data = [
        { label: 'Display Name', value: credential.display || '--' },
        { label: 'Company', value: credential.company || '--' },
        { label: 'IP Address', value: credential.ip_address || '--' },
        { label: 'Port', value: credential.port || '--' },
      ];
    } else if (
      type === 'Gmail' ||
      type === 'Outlook' ||
      type === 'OneDrive' ||
      type === 'SharePoint' ||
      type === 'GoogleDrive' ||
      type === 'Xero' ||
      type === 'QuickBook'
    ) {
      data = [
        { label: 'Display Name', value: displayName },
        { label: 'Email', value: credential.email || '--' },
      ];
    } else if (type === 'Zoho') {
      data = [
        { label: 'Display Name', value: displayName },
        { label: 'Email', value: credential.email || '--' },
        { label: 'API Domain', value: credential.apiDomain || '--' },
      ];
    } else if (type === 'Odoo') {
      data = [
        { label: 'Display Name', value: displayName },
        { label: 'Username', value: credential.username || '--' },
        { label: 'URL', value: credential.url || '--' },
        { label: 'Database', value: credential.db || '--' },
      ];
    }
    setCredentialData(data);
  }, [type, displayName, credential]);
  useEffect(() => {
    if (!isShowMore) {
      if (taxMapping && taxMapping.length > 0) {
        const result = taxMapping.slice(0, 2);
        setTaxData(result);
      }
    } else {
      setTaxData(taxMapping);
    }
  }, [taxMapping, isShowMore]);
  const showMoreTax = () => {
    setIsShowMore((prev) => !prev);
  };

  return (
    <>
      <Card className={classes.cardContianer}>
        <CardContent>
          <Grid container spacing={2} alignItems="flex-start">
            {/* Icon Section */}
            <Grid item xs={2} sm={2} md={2} lg={1} xl={1}>
              <Box className={classes.cardAvtar}>
                {/* Replace with your actual logo */}
                <Icon className={classes.iconBox} />
              </Box>
            </Grid>

            {/* Content Section */}
            <Grid item xs={8} sm={8} md={8} lg={9} xl={9}>
              <Grid container spacing={1}>
                {credentialData.map((elem, index) => (
                  <Grid key={index} item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Grid container>
                      <Grid item xs={6}>
                        <Typography variant="body1">{elem.label}</Typography>
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <Typography
                          variant="subtitle2"
                          sx={{ color: 'text.secondary' }}
                        >
                          {elem.value}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <Box className={classes.taxMappingText}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: 'primary.main', mb: 1 }}
                >
                  Tax Mapping
                </Typography>
                <Grid container spacing={1}>
                  {taxMapping && taxMapping.length > 0 ? (
                    taxData.map((elem, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        key={index}
                      >
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 'bold' }}
                            >
                              {elem.label}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sx={{ textAlign: 'left' }}>
                            <Typography variant="body2">
                              {elem.value}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    ))
                  ) : (
                    <Grid
                      item
                      xs={12}
                      sx={{ display: 'flex', justifyContent: 'center' }}
                    >
                      <Typography
                        variant="body2"
                        color={darkPalette.orange.dark}
                      >
                        Tax Mapping Data Not Available
                      </Typography>
                    </Grid>
                  )}
                </Grid>
                {taxMapping && taxMapping.length > 2 && (
                  <Typography
                    variant="body2"
                    color={darkPalette.orange.dark}
                    className={classes.viewMore}
                    onClick={showMoreTax}
                  >
                    {!isShowMore ? 'View More Mapping' : 'View Less Mapping'}
                  </Typography>
                )}
              </Box>
            </Grid>

            {/* Action Buttons */}
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 1,
                }}
              >
                <Button
                  onClick={() => {
                    handleUpdate(id, type);
                  }}
                  className={classes.editButton}
                >
                  <EditIcon />
                </Button>
                <Button
                  className={classes.deleteButton}
                  onClick={() => {
                    handleOpenDialog(id, type);
                  }}
                >
                  <DeleteIcon sx={{ color: 'purple' }} />
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Backdrop className={classes.newFlowBackdrop} open={open}>
        <Card className={classes.cardComponent}>
          <CardHeader
            className={classes.DeleteMemberCardHeader}
            title={
              <Grid container alignItems="center">
                <Grid item xs={10}>
                  <Typography variant="h4">Delete Credential</Typography>
                </Grid>
                <Grid item xs={2} align="right">
                  <Avatar
                    onClick={handleCloseDialog}
                    src={closeIcon}
                    className={classes.closeAction}
                  />
                </Grid>
              </Grid>
            }
          />

          <CardContent className={classes.DeleteMemberCardContent}>
            <Typography>Are you sure you want to delete?</Typography>
            <Box className={classes.actionButtonBox}>
              <Button
                className={classes.cancelButton}
                onClick={handleCloseDialog}
              >
                <Typography variant="body1">No</Typography>
              </Button>
              <Button
                variant="contained"
                className={classes.saveButton}
                onClick={() =>
                  handleDeleteCredential(
                    deleteData.credentialId,
                    deleteData.selectedType,
                  )
                }
              >
                <Typography variant="body1">Yes</Typography>
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Backdrop>
    </>
  );
};

CardComponent.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  credential: PropTypes.shape({
    port: PropTypes.string.isRequired,
    ip_address: PropTypes.string.isRequired,
    company: PropTypes.string.isRequired,
    display: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    apiDomain: PropTypes.string.isRequired,
    db: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
  }).isRequired,
  type: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  taxMapping: PropTypes.arrayOf.isRequired,
  id: PropTypes.string.isRequired,
  handleDeleteCredential: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
};

export default CardComponent;
